export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.25 3A.75.75 0 019 2.25h6a.75.75 0 010 1.5h-2.25v2.536a7.718 7.718 0 014.174 1.73L18.47 6.47a.75.75 0 111.06 1.06l-1.545 1.546a7.75 7.75 0 11-6.735-2.79V3.75H9A.75.75 0 018.25 3zM12 7.75a6.25 6.25 0 100 12.5 6.25 6.25 0 000-12.5zm-3.53 3.78a.75.75 0 111.06-1.06l3 3a.75.75 0 11-1.06 1.06l-3-3z\" fill=\"#6F7488\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};